/**
 * AF class.
 */

/**
 * AF constructor.
 * @constructor
 */
function AF() {

	let i;

	/**
	 * Plugins
	 */
	this.plugins = [];

	/**
	 * Plugins Instances.
	 * @type {Array}
	 */
	this.pluginsInstances = [];

	/**
	 * Loaded and prepared clubs.
	 * @type {Array}
	 */
	this.clubs = [];

	/**
	 * Current page.
	 */
	this.page = null;

	this.plugins.push( TelPlugin );

	// init plugins
	for ( i in this.plugins ) {
		this.pluginsInstances[i] = new this.plugins[i];
	}

}

/**
 * Decode Club information from server.
 *
 * @static
 * @param {object} serverClub - object from the server.
 * @return {AFClub} a new AFClub object.
 */
AF.decodeClub = function( serverClub ) {
	let isLocal = false;
	if (mapGlobalOptions.franchisee_country_code == 'QC' && 0 <= mapGlobalOptions.site_country_code.indexOf( serverClub.content.country )) {
		isLocal = (serverClub.content.country == 'CA' && serverClub.content.state_abbr == 'QC');
	} else {
		isLocal = 0 <= mapGlobalOptions.site_country_code.indexOf( serverClub.content.country ) && serverClub.content.state_abbr != 'QC';
	}
	return new AFClub( {
		address: serverClub.content.address,
		address2: serverClub.content.address2 ?? '',
		city: serverClub.content.city,
		countryAbbr: serverClub.content.country,
		distance: serverClub.content.distance,
		email: serverClub.content.email,
		id: serverClub.content.number,
		// passCustom is boolean always in JavaScript.
		passCustom: ! ! serverClub.content.pass_custom,
		passLength: serverClub.content.pass_length,
		passUrl: serverClub.content.pass_url ? serverClub.content.pass_url : dynamicURLs.tryUsFreePage + '?club=' + serverClub.content.number,
		phone: serverClub.content.phone,
		shouldBeExcludedFromMaps: serverClub.content.should_be_excluded_from_maps,
		state: serverClub.content.state,
		stateAbbr: serverClub.content.state_abbr,
		status: serverClub.content.status_id ?? serverClub.content.status,
		title: serverClub.content.title,
		url: serverClub.content.website_url ?? serverClub.content.url,
		zip: serverClub.content.zip,
		lat: parseFloat( serverClub.latitude ),
		long: parseFloat( serverClub.longitude ),
		isLocalClub: isLocal
	} );
};

AF.domUpdated = function() {
	jQuery( 'body' ).trigger( 'update_dom' );
};

/**
 * Decode Clubs information from server.
 */
AF.decodeClubs = function( jsonClubs ) {
	return jsonClubs.map( AF.decodeClub );
};

/**
 * Return Club-object by AF Number.
 *
 * @param {string} afNumber AF Number.
 * @return {AFClub}
 */
AF.prototype.getClubByAfNumber = function( afNumber ) {
	if ( this.clubs[afNumber.toString()] !== undefined ) {
		return this.clubs[afNumber.toString()];
	}
};

/**
 * Import clubs from server side.
 * @param {array} serverClubs array of club from Back-end.
 */
AF.prototype.importClubs = function( serverClubs ) {
	let ind,
		club,
		clubs = AF.decodeClubs( serverClubs );
	for ( ind in clubs ) {
		if ( Object.prototype.hasOwnProperty.call(clubs, ind ) ) {
			club = clubs[ind];
			this.clubs[club.id.toString()] = club;
		}
	}
};

/**
 * Init all sub modules.
 */
AF.prototype.init = function() {
	let tryUsFreeUrlPathName,
		current = document.location.pathname;
	tryUsFreeUrlPathName = this.option( 'dynamicURLs.tryUsFreePage', null ).replace( /^http[s]?:\/\/[^/]+/, '' );
	if ( 0 === current.indexOf( tryUsFreeUrlPathName ) ) {
		this.page = new AFTryUsFreePage();
		this.page.init();
	} else {
		if ( this.page ) {
			this.page.destroy();
		}
		this.page = null;
	}
};

/**
 * Return option from appOptions.
 *
 * @example app.option('value')
 * @example app.option('value.subvalue')
 * @example app.option('value.subvalue', 'default')
 *
 * @param {string} optionName - option name for return value.
 * @param {mixed} defaultValue - default value for option.
 * @return {mixed}
 */
AF.prototype.option = function( optionName, defaultValue ) {
	let firstOptionPath,
		options,
		optionPath,
		value;
	if ( appOptions ) {
		optionPath = optionName.split( '.' );
		options = appOptions;
		while ( optionPath.length && 'object' === typeof options ) {

			// optionPath
			firstOptionPath = optionPath.shift();
			if ( options[firstOptionPath] !== undefined ) {
				if ( 0 === optionPath.length ) {
					value = options[firstOptionPath];
					break;
				} else {
					options = options[firstOptionPath];
				}
			} else {
				break;
			}
		}
		if ( optionPath.length && 'object' !== typeof options && options[firstOptionPath] !== undefined ) {
			value = appOptions[firstOptionPath];
		}
	}
	return value !== undefined ? value : ( defaultValue !== undefined ? defaultValue : null );
};
